import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const violationTypeConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default violationTypeConfig;
